import { render, staticRenderFns } from "./AlbaraOrdreEixidaEdit.vue?vue&type=template&id=298ecc68&scoped=true"
import script from "./AlbaraOrdreEixidaEdit.vue?vue&type=script&lang=js"
export * from "./AlbaraOrdreEixidaEdit.vue?vue&type=script&lang=js"
import style0 from "./AlbaraOrdreEixidaEdit.vue?vue&type=style&index=0&id=298ecc68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298ecc68",
  null
  
)

export default component.exports